import curry from 'shadow-fns/src/curry'
import has from 'shadow-fns/src/has'
import isObject from './isObject'

export const hasOwn = curry((o, k) => isObject(o) && has(k)(o))
export default hasOwn
